import React from 'react';
import CommonModal from './Modal';
import _ from 'lodash';

const ConfirmAppStart = props => {
  const {
    visible = false,
    title = '',
    message = '',
    confirmButtonText = '利用を開始する',
    cancelButtonText = 'キャンセル',
    isNegative = false,
    onConfirm,
    onCancel,
    isSubmitting = false,
    disabledConfirmButton = false,
    rootClassName,
    negativeButtonClassName = 'btn--negative',
    effectiveButtonClassName = 'btn--effective',
    cancelButtonClassName = 'btn--sub',
    isVerticalButton = false,
    multilineText = false, // 通常のダイアログは左寄せ(true)
    checkBoxText = '', // 通常のダイアログは左寄せ(true)
    onConfirmCheckbox,
    confirmCheckbox = 0,
    downloadPdf,
    uid = _.uniqueId(),
  } = props;

  return (
    <React.Fragment>
      {visible && (
        <CommonModal visible={visible}>
          <div
            className={
              rootClassName
                ? `${rootClassName} confirm-app-start-modal dialog-md dialog--modal`
                : 'dialog-md dialog--modal'
            }
          >
            {title !== '' && (
              <div className='dialog-md__header'>
                <span
                  className='dialog-md__title'
                  data-testid='confirmation_title'
                >
                  {title}
                </span>
              </div>
            )}
            {message !== '' && (
              <div
                className={
                  multilineText
                    ? 'dialog-md__body dialog-md__body-prewrap text-left'
                    : 'dialog-md__body text-left'
                }
                data-testid='confirmation_body'
              >
                {message}
                <ul
                  className='detail'
                  style={{
                    listStyle: 'disc',
                    lineHeight: '20px',
                    paddingTop: '15px',
                    paddingLeft: '15px',
                  }}
                >
                  <li className='detail__text'>
                    <button
                      className='btn-text--sm no-padding'
                      onClick={downloadPdf}
                    >
                      利用料金表
                    </button>
                  </li>
                  <li className='detail__text'>
                    <a
                      className='clickable-text'
                      //TODO: 仮のURLです。URLを決まったら差し替え必要。
                      href='https://service.buildee.jp/support/agreement/'
                      target='_blank'
                      rel='noreferrer noopener'
                    >
                      利用規約・個人情報について
                    </a>
                  </li>
                </ul>

                <label htmlFor={`check-stamp${uid}`}>
                  <div
                    style={{
                      lineHeight: '25px',
                      paddingTop: '20px',
                      textAlign: 'center',
                    }}
                  >
                    <input
                      id={`check-stamp${uid}`}
                      type='checkbox'
                      checked={confirmCheckbox}
                      onChange={onConfirmCheckbox}
                    />
                    <span style={{ paddingLeft: '5px' }}>{checkBoxText}</span>
                  </div>
                </label>
              </div>
            )}
            <div
              className={
                isVerticalButton
                  ? 'dialog-md__footer'
                  : 'dialog-md__footer-horizontal'
              }
            >
              {isNegative ? (
                <React.Fragment>
                  <button
                    className={cancelButtonClassName}
                    onClick={onCancel ? onCancel : undefined}
                    disabled={isSubmitting ? 'disabled' : ''}
                  >
                    {cancelButtonText}
                  </button>
                  <button
                    className={negativeButtonClassName}
                    onClick={onConfirm ? onConfirm : undefined}
                    disabled={
                      isSubmitting || disabledConfirmButton ? 'disabled' : ''
                    }
                  >
                    {confirmButtonText}
                  </button>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <button
                    className={cancelButtonClassName}
                    onClick={onCancel ? onCancel : undefined}
                    disabled={isSubmitting ? 'disabled' : ''}
                  >
                    {cancelButtonText}
                  </button>
                  <button
                    className={effectiveButtonClassName}
                    onClick={onConfirm ? onConfirm : undefined}
                    disabled={
                      isSubmitting || disabledConfirmButton ? 'disabled' : ''
                    }
                  >
                    {confirmButtonText}
                  </button>
                </React.Fragment>
              )}
            </div>
          </div>
        </CommonModal>
      )}
    </React.Fragment>
  );
};

export default ConfirmAppStart;



// WEBPACK FOOTER //
// ./src/components/modals/common/ConfirmAppStart.jsx